import styled from 'styled-components'

export const Container = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 16px;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  width: 700px;
  max-width: 95vw;
  color: #303030;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
`

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px 24px 16px 24px;
`

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  color: #303030;
`

export const TitleEditWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const TitleInput = styled.input`
  font-size: 20px;
  font-weight: 700;
  color: #303030;
  border: 1px solid #0090D3;
  border-radius: 6px;
  padding: 8px 12px;
  outline: none;
  min-width: 300px;
  
  &:focus {
    box-shadow: 0 0 0 2px rgba(0, 144, 211, 0.2);
  }
`

export const TitleEditButtons = styled.div`
  display: flex;
  gap: 8px;
  
  button {
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    background: #0090D3;
    color: white;
    
    &:hover {
      background: #007ab8;
    }
    
    &.cancel {
      background: #e0e0e0;
      color: #666;
      
      &:hover {
        background: #d0d0d0;
      }
    }
  }
`

export const CreatedAt = styled.span`
  font-size: 12px;
  color: #8c8c8c;
`

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const OptionsButton = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e0e0e0;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  
  &:hover {
    background: #f5f5f5;
  }
`

export const SaveButton = styled.button`
  background-color: #0090D3;
  color: #fff;
  padding: 10px 20px;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 24px;
  cursor: pointer;
  border: none;
  
  &:hover {
    background-color: #007ab8;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 24px 24px 24px;
`

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 16px;
  align-items: center;
`

export const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #303030;
`

export const Input = styled.input`
  width: 100%;
  border: none;
  outline: none;
  background-color: #EBEBEB;
  height: 44px;
  padding: 0 16px;
  border-radius: 24px;
  font-size: 14px;
  color: #303030;
  
  &::placeholder {
    color: #999;
  }
`

export const SelectInput = styled.div`
  position: relative;
  width: 100%;
  
  select {
    width: 100%;
    border: none;
    outline: none;
    background-color: #EBEBEB;
    height: 44px;
    padding: 0 16px;
    border-radius: 24px;
    font-size: 14px;
    color: #303030;
    appearance: none;
    cursor: pointer;
  }
  
  &::after {
    content: '';
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #666;
    pointer-events: none;
  }
`

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  background-color: #EBEBEB;
  padding: 10px 16px;
  border-radius: 24px;
  min-height: 44px;
  align-items: center;
`

export const TagsInputContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  background-color: #EBEBEB;
  padding: 10px 16px;
  border-radius: 24px;
  min-height: 44px;
  align-items: center;
  position: relative;
  cursor: pointer;
`

export const Tag = styled.span<{color?: string}>`
  background-color: ${props => props.color || '#e0f2fe'};
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  
  button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 14px;
    color: #666;
    padding: 0;
    line-height: 1;
    
    &:hover {
      color: #333;
    }
  }
`

export const AddTagButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  padding: 4px;
`

export const TagDropdownIcon = styled.div`
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #666;
`

export const TagDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1002;
  min-width: 180px;
  max-height: 200px;
  overflow-y: auto;
`

export const TagDropdownItem = styled.button`
  width: 100%;
  padding: 10px 16px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  color: #303030;
  display: flex;
  align-items: center;
  gap: 8px;
  
  &:hover {
    background: #f5f5f5;
  }
`

export const TagColor = styled.div<{color?: string}>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${props => props.color || '#FFEFB7'};
`

export const TagDropdownEmpty = styled.div`
  padding: 10px 16px;
  font-size: 14px;
  color: #999;
  text-align: center;
`

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const Checkbox = styled.div<{checked: boolean}>`
  display: inline-block;
  width: 30px;
  height: 30px;
  background: ${props => props.checked ? '#0090D3' : '#fff'};
  border: 1px solid ${props => props.checked ? '#0090D3' : '#C4C4C4'};
  border-radius: 6px;
  transition: all 0.2s ease;
  position: relative;
  cursor: pointer;

  &:after {
    content: '';
    position: absolute;
    display: ${props => props.checked ? 'block' : 'none'};
    left: 8px;
    width: 8px;
    top: 4px;
    height: 14px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`

export const Divider = styled.div`
  grid-column: 1 / -1;
  height: 1px;
  background-color: #e0e0e0;
  margin: 8px 0;
`

export const TextArea = styled.textarea`
  grid-column: 1 / -1;
  width: 100%;
  border: none;
  outline: none;
  background-color: #EBEBEB;
  padding: 16px;
  border-radius: 16px;
  font-size: 14px;
  color: #303030;
  min-height: 100px;
  resize: vertical;
  font-family: inherit;
  
  &::placeholder {
    color: #999;
  }
`

export const DescriptionLabel = styled.label`
  grid-column: 1 / -1;
  font-size: 14px;
  font-weight: 600;
  color: #303030;
  margin-top: 8px;
`

export const Section = styled.div`
  margin-top: 24px;
`

export const SectionDivider = styled.div`
  height: 1px;
  background-color: #e0e0e0;
  margin: 24px 0 0 0;
`

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`

export const SectionTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: #303030;
  margin: 0;
`

export const SectionAction = styled.button`
  background: none;
  border: none;
  color: #0090D3;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  
  &:hover {
    text-decoration: underline;
  }
`

export const AttachmentList = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`

export const AttachmentItem = styled.div`
  width: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  position: relative;
`

export const AttachmentIcon = styled.div`
  width: 70px;
  height: 70px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  position: relative;
  cursor: pointer;
  
  &:hover {
    background: #f9f9f9;
  }
  
  img {
    max-width: 60px;
    max-height: 60px;
    object-fit: contain;
  }
`

export const AttachmentName = styled.span`
  font-size: 11px;
  color: #666;
  text-align: center;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const AttachmentMenu = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #e0e0e0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #666;
`

export const TaskList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const TaskItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
`

export const TaskCheckbox = styled.div<{checked: boolean}>`
  width: 20px;
  height: 20px;
  border: 2px solid ${props => props.checked ? '#0090D3' : '#C4C4C4'};
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.checked ? '#0090D3' : '#fff'};
  flex-shrink: 0;
  
  &::after {
    content: '';
    display: ${props => props.checked ? 'block' : 'none'};
    width: 5px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    margin-bottom: 2px;
  }
`

export const TaskTitle = styled.span<{completed: boolean}>`
  flex: 1;
  font-size: 14px;
  color: ${props => props.completed ? '#8c8c8c' : '#303030'};
  text-decoration: ${props => props.completed ? 'line-through' : 'none'};
`

export const TaskMenu = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #666;
  
  &:hover {
    color: #333;
  }
`

export const AddTaskInput = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  
  input {
    flex: 1;
    border: none;
    border-bottom: 1px solid #e0e0e0;
    padding: 8px 0;
    font-size: 14px;
    outline: none;
    
    &:focus {
      border-bottom-color: #0090D3;
    }
  }
  
  button {
    background: #0090D3;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    
    &:hover {
      background: #007ab8;
    }
  }
`

export const FileIcon = styled.div`
  font-size: 24px;
  color: #666;
`

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1002;
  min-width: 120px;
  overflow: hidden;
`

export const AttachmentDropdownPortal = styled.div`
  position: fixed;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 2147483647;
  width: fit-content;
  min-width: 100px;
  overflow: hidden;
  animation: fadeIn 0.15s ease;
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-5px); }
    to { opacity: 1; transform: translateY(0); }
  }
`

export const DropdownItem = styled.button`
  width: 100%;
  padding: 8px 14px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  font-size: 13px;
  color: #303030;
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  
  &:hover {
    background: #f5f5f5;
  }
  
  &.danger {
    color: #e74c3c;
  }
  
  &.danger:hover {
    background: #fef2f2;
  }
  
  svg {
    flex-shrink: 0;
    color: #666;
  }
  
  &.danger svg {
    color: #e74c3c;
  }
`
